import Card from 'app/shared-components/Card'
import ChangeHistory from 'app/shared-components/ChangeHistory'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import requests from 'app/requests/LongTermLease/LongTermLease.requests'

import useStyles from './contractChangeHistory.styles'
import RequiredContainersChange from './RequiredContainersChange'
import DedicatedContainersChange from './DedicatedContainersChange'

const ContractChangeHistory = ({
    id,
}: {
    id: number
}) => {
    const {
        classes,
    } = useStyles()

    return (
        <>
            <Card
                className={classes.root}
                title="Required Containers Change"
            >
                <RequiredContainersChange longTermLeaseId={id} />
            </Card>
            <Card
                className={classes.root}
                title="Dedicated Containers Change"
            >
                <DedicatedContainersChange longTermLeaseId={id} />
            </Card>
            <ChangeHistory
                id={id}
                requestKey={RequestKeys.getLongTermLeaseModifications}
                config={requests.modifications}
                configName="LongTermLeaseHistoryTable"
                name="LongTermLeaseChangeHistory"
                labelPrefixForChangedColumn={['LongTermLease']}
                title="Contract Change Summary"
            />
        </>
    )
}

export default ContractChangeHistory
